<template>
  <div class="recruitList">
    <Headers></Headers>
    <div class="container">
      <el-row class="warp">
        <el-col :lg="6" :md="8" :xs="0" class="right">
          <div class="inner">
            <div class="title">
              <span class="new">最新职位</span>
              <!-- <span class="more">更多</span> -->
            </div>
            <div class="common" v-for="(item, index) in recentJobList" :key="index" @click="goto(item.id)">{{item.jobName}}</div>
          </div>
        </el-col>
        <el-col :lg="18" :md="18" :xs="24" class="left">
          <div class="searchBox">
            <div class="title">
              <span>职位筛选</span>
              <!-- <div class="share">分享到 <i class="el-icon-arrow-down"></i> </div> -->
            </div>
            <div class="keyword">
              <el-row>
                <el-col :lg="21" :md="21" :xs="16">
                  <el-input
                    v-model="jobName"
                    clearable
                    placeholder="请输入职位关键字"
                  />
                </el-col>
                <el-col :lg="3" :md="3" :xs="8">
                  <el-button v-waves type="primary" @click="clickSearch">搜索职位</el-button>
                </el-col>
              </el-row>
            </div>
            <div class="searchDetails">
              <el-row>
                <!-- <el-col :lg="6" :md="6" :xs="24">
                  <el-select
                    size="medium"
                    v-model="place"
                    clearable
                    placeholder="请选择工作地点"
                  >
                    <el-option
                      v-for="item in placeList"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col> -->
                <el-col :lg="6" :md="6" :xs="24">
                  <el-select
                    size="medium"
                    v-model="type"
                    clearable
                    filterable
                    placeholder="请选择职能类型"
                    @change="clickSearch"
                  >
                    <el-option
                      v-for="item in typeList"
                      :key="item.id"
                      :label="item.jobType"
                      :value="item.jobType"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-button v-waves size="medium" @click="clearCondition">清空条件</el-button>
              </el-row>
            </div>
          </div>
          <div class="positionList">
            <div class="common" v-for="(item, index) in jobList" :key="index" @click="goto(item.id)">
              <div class="name">{{item.jobType}}</div>
              <div class="type">{{item.jobName}}</div>
              <div class="placeAndTime">
                <span>{{item.workCity}}</span>
                <span>发布时间: {{item.createTime.split(" ")[0]}}</span>
              </div>
            </div>
          </div>
          <div class="pagination">
            <el-pagination
              background
              layout="prev, pager, next,sizes"
              @size-change="handleSizeChange"
              :current-page="pageNum"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSize"
              :total="totalCount"
            >
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <Footer></Footer>
  </div>
</template>
  
<script>
import Headers from "@/components/Headers.vue";
import Footer from "@/components/Footer.vue";
import waves from "@/directive/waves";


export default {
  name: "recruitList",
  components: { Headers,Footer },
  directives: {
    waves,
  },
  data() {
    return {
      jobName:'',
      place:'',
      placeList: [
        {
          id: 1,
          value: 1,
          name: "台虹厂",
        },
        {
          id: 2,
          value: 2,
          name: "古城厂",
        },
        {
          id: 3,
          value: 3,
          name: "汉浦厂",
        },
      ],
      type: "",
      typeList: [],
      jobList:[],
      recentJobList:[], //最新职位
      pageSize: 10,
      pageNum: 1,
      totalCount: 0
    };
  },
  created(){
    this.jobName = this.$route.params.jobName;
    this.type = this.$route.params.type;
    this.getList();
    this.getJobTypeList();
    this.getRecentJobList();
  },
  methods: {
    clearCondition(){
      this.jobName = "";
      this.type = "";
      this.place = "";
    },
    clickSearch(){
      this.pageNum = 1;
      this.getList();
    },
    getRecentJobList(){
      let params = {
        current:1,
        pageSize:5
      };
      this.axios({
        url: "/apis/job/list",
        method: "get",
        params: params,
      }).then((res) => {
        if (res.code == 200) {
          this.recentJobList = res.rows;
        } else {
          this.recentJobList = [];
        }
      });
    },
    getJobTypeList(){
      let params = {
        current:1,
        pageSize:1000
      };
      this.axios({
        url: "/apis/jobType/list",
        method: "get",
        params: params,
      }).then((res) => {
        if (res.code == 200) {
          this.typeList = res.rows;
        } else {
          this.typeList = [];
        }
      });
    },
    // 获取列表
    getList(){
      let params = {
        pageSize: this.pageSize,
        current: this.pageNum,
        jobType: this.type,
        jobName: this.jobName
      }
      this.axios({
        url: "/apis/job/list",
        method: "get",
        params: params,
      }).then((res) => {
        if (res.code == 200) {
          this.jobList = res.rows;
          this.totalCount = res.total;
        } else {
          this.jobList = [];
          this.totalCount = 0;
        }
      });
    },
    goto(id) {
      this.$router.push('/recruitDetails?id='+id);
    },
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.pageNum = 1;
      this.pageSize = pageSize;
      this.getList();
    },
  },
};
</script>
  
<style lang="scss" scoped>
.recruitList {
  background-color: #f4f4f6;
  padding-top: 60px;
  .container {
    padding: 30px 0 120px;
    height: 100%;
    @media (max-width: 1200px) {
      padding: 0 0 15px;
    }
    .warp {
      width: 1200px;
      margin: 0 auto;
      @media (max-width: 1200px) {
        width: 100%;
      }
      .left {
        .searchBox {
          background-color: #fff;
          padding: 0 30px 30px;
          margin-bottom: 10px;
          @media (max-width: 1200px) {
            padding: 0 15px 15px;
          }
          .title {
            height: 55px;
            line-height: 55px;
            span {
              float: left;
              color: #222831;
              font-size: 16px;
            }
            div {
              float: right;
              color: #9a9fac;
              font-size: 12px;
              cursor: pointer;
            }
          }
          .keyword {
            overflow: hidden;
            position: relative;
            margin-bottom: 15px;
            .el-input{
              input{
                border-radius: 0;
              }
            }
            button {
              cursor: pointer;
              width: 100%;
              // padding: 0 23px;
              // font-size: 14px;
              // line-height: 40px;
              // position: absolute;
              // right: 0;
              // bottom: 0;
              // background-color: #3da3f8;
              // vertical-align: middle;
              // border: none;
              // color: #fff;
              // border-radius: 0 4px 4px 0;
            }
          }
          .searchDetails {
            .el-col {
              &:first-of-type {
                margin-right: 15px;
                @media (max-width: 1200px) {
                  margin-right: 0;
                  margin-bottom: 15px;
                }
              }
            }
            .el-select {
              width: 100%;
            }
            button{
              float: right;
              border: 1px solid #3da3f8;
              color: #3da3f8;
              @media (max-width: 1200px) {
                margin-top: 0;
              }
            }
          }
        }
        .positionList {
          background-color: #fff;
          .common {
            &:hover {
              background-color: #f4f4f6;
            }
            cursor: pointer;
            padding: 20px 20px 0;
            @media (max-width: 1200px) {
              padding: 10px 20px 0;
            }
            text-align: left;
            &:last-of-type {
              .placeAndTime {
                border: none;
              }
            }
            .name {
              max-width: 350px;
              margin-bottom: 10px;
              color: #222831;
              font-size: 16px;
              line-height: 22px;
            }
            .type {
              color: #a2a4a8;
              font-size: 14px;
              line-height: 20px;
            }
            .placeAndTime {
              margin-top: 10px;
              border-bottom: 1px solid #eee;
              padding-bottom: 20px;
              @media (max-width: 1200px) {
                padding-bottom: 10px;
              }
              span {
                vertical-align: middle;
                &:nth-child(1) {
                  color: #474c66;
                  font-size: 14px;
                  white-space: pre;
                }
                &:nth-child(2) {
                  float: right;
                  color: #a2a4a8;
                  font-size: 12px;
                }
              }
            }
          }
        }
        .pagination{
          margin-top: 30px;
        }
      }
      .right {
        background-color: #f4f4f6;
        padding-right: 10px;
        @media (max-width: 1200px) {
          display: none;
        }
        .inner {
          background-color: #fff;
          .title {
            padding: 0 20px;
            color: #090a0b;
            font-size: 16px;
            line-height: 60px;
            height: 60px;
            span {
              &.new {
                color: #222831;
                font-size: 16px;
                float: left;
              }
              &.more {
                float: right;
                color: #9a9fac;
                font-size: 12px;
                line-height: 60px;
                cursor: pointer;
              }
            }
          }
          .common {
            text-align: left;
            padding: 16px 20px;
            border-bottom: 0.5px dashed #eee;
            color: #5c6170;
            font-size: 14px;
            line-height: 20px;
            white-space:nowrap;//禁止换行
            overflow:hidden ;//超出隐藏
            text-overflow: ellipsis;//显示省略号
            cursor: pointer;
            &:last-of-type {
              border: none;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
  .recruitList{
    .keyword{
      .el-input--suffix{
        .el-input__inner{
          border-radius: 4px 0 0 4px;
        }
      }
      button{
        border-radius: 0 4px 4px 0;
      }
    }
    .el-pagination span{
      @media (max-width: 1200px) {
        display: none !important;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/onlineApp/list.vue